module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns-house_access_01-7015f2ad5e875f309d59464e1777e83a.jpg";